import React from "react";
import { Navigate } from "react-router-dom";

import { userRoles } from "@/Core";
import { routesIndex } from "@/RoutesIndex";
import { useAppSelector } from "@/redux/hooks";

const DataConsistency = React.lazy(() => import("./DataConsistency"));

export const DataConsistencyGuard = () => {
    const role = useAppSelector((s) => s.authentication.data?.user?.role);
    if (role !== userRoles.administrator) {
        return <Navigate to={routesIndex.app.search} replace />;
    }
    return <DataConsistency />;
};
